import { render, staticRenderFns } from "./DlgFileEdit.vue?vue&type=template&id=501ebbd8&scoped=true&"
import script from "./DlgFileEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgFileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ebbd8",
  null
  
)

export default component.exports